import AggregateVersionsDrawer from "@/shared/components/versions/AggregateVersionsDrawer";
import type { IngestConfigVersion } from "@models/configVersion.model";

interface Props {
  open: boolean;
  onClose: () => void;
  versions: IngestConfigVersion[];
  definitionName?: string;
}

/**
 * The field map's version history. Presentation lives in the shared drawer — engagements render
 * the same rows (MPN-1334) — and only the field-map specifics stay here: the run count, which
 * exists because an IngestRun pins the version it ran, and the trigger that records that pin.
 */
export default function ConfigVersionsDrawer({ open, onClose, versions, definitionName }: Props) {
  return (
    <AggregateVersionsDrawer
      open={open}
      onClose={onClose}
      versions={versions}
      subtitle={definitionName}
      emptyMessage="No versions yet. Saving the field map creates the first version."
      triggerLabels={{ pin_for_run: "pinned for a file run" }}
      renderMeta={(v) => {
        const runs = (v as IngestConfigVersion).run_count;
        return `Used by ${runs} run${runs === 1 ? "" : "s"}`;
      }}
    />
  );
}
